
import { Suspense } from "react";
import Hero from "@/components/Hero";
import WhyChooseUs from "@/components/WhyChooseUs";
import Services from "@/components/Services";
import About from "@/components/About";
import Packages from "@/components/Packages";
import Contact from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { Loader2 } from "lucide-react";
import { Reviews } from "@/components/Reviews";
import AffiliateAccommodations from "@/components/AffiliateAccommodations";
import SocialMediaPosts from "@/components/SocialMediaPosts";

const LoadingSpinner = () => (
  <div className="min-h-screen flex items-center justify-center bg-background">
    <Loader2 className="w-8 h-8 animate-spin text-primary" />
  </div>
);

const Index = () => {
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <main className="min-h-screen bg-background">
        <Hero />
        <div className="relative z-10 bg-shell-light">
          <Packages />
        </div>
        <AffiliateAccommodations />
        <About />
        <Services />
        <WhyChooseUs />
        <Reviews />
        <SocialMediaPosts />
        <Contact />
        <Footer />
      </main>
    </Suspense>
  );
};

export default Index;
